// extracted by mini-css-extract-plugin
export default {"menu":"CreateMenu_menu__SXAUK"};